<template>
    <div class="student-task-list-page">
        <card header-classes="bg-transparent" body-classes="bg-transparent p-0">
            <div slot="header" class="row align-items-center">
                <div class="col-lg-6">
                    <h6 class="text-uppercase ls-1 mb-1">Aktivitas User</h6>
                </div>
                <div class="col-lg-6 text-lg-right">
                    
                </div>
            </div>
            <div class="text-center text-muted">
                <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
                    <div class="p-2">
                        <b-row>
                            <b-col lg="1" class="my-1">
                                <b-form-select
                                    id="per-page-select"
                                    v-model="perPage"
                                    :options="pageOptions"
                                    size="sm"
                                ></b-form-select>
                            </b-col>
                            <b-col lg="2" class="my-1">
                                <b-input-group size="sm">
                                    <b-form-select
                                        v-model="filter_form.userId"
                                        name="userId"
                                        v-validate="'required'"
                                        value-field="id"
                                        placeholder="Nama User"
                                        text-field="name"
                                        data-vv-as="Nama User"
                                        :options="userList"
                                    >
                                        <b-form-select-option :value="null" disabled>Pilih User</b-form-select-option>
                                    </b-form-select>
                                </b-input-group>
                            </b-col>
                            <b-col lg="4" class="my-1">
                                <b-input-group size="sm">
                                    <b-form-datepicker
                                        id="start-date"
                                        v-model="filter_form.startDate"
                                        name="startDate"
                                        placeholder="Dari Tanggal"
                                        v-validate="'required'"

                                    ></b-form-datepicker>
                                </b-input-group>
                            </b-col>
                            <b-col lg="5" class="my-1">
                                <b-input-group size="sm">
                                    <b-form-datepicker
                                        id="end-date"
                                        v-model="filter_form.endDate"
                                        name="endDate"
                                        placeholder="Sampai Tanggal"
                                        v-validate="'required'"

                                    ></b-form-datepicker>
                                    <b-input-group-append>
                                        <b-button variant="primary" :disabled="!filter_form.userId || !filter_form.startDate || !filter_form.endDate" style="border-radius:0px !important;" class="btn btn-primary" @click="getUserActivity(filter_form)">Filter</b-button>
                                        <b-button variant="primary" :disabled="!filter_form.userId || !filter_form.startDate || !filter_form.endDate" style="border-radius:0px !important;" class="btn btn-info" @click="downloadExcel(filter_form)">Excel</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>
                        </b-row>
                        <b-table
                            :items="userActivityList"
                            :fields="fields"
                            :busy="isBusy"
                            :current-page="currentPage"
                            :per-page="perPage"
                            :filter="filter"
                            :filter-included-fields="filterOn"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            :sort-direction="sortDirection"
                            responsive="sm"
                            show-empty
                            small
                            @filtered="onFiltered"
                        >
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <img class="img-loading" src="../../../assets/img/logo-daring.png" alt="Logo"/><br>
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                            </template>
                            <template #cell(full_name)="row">
                                <div class="list-murid text-left">
                                    <label>{{row.item.full_name}}</label>
                                </div>
                            </template>
                            <template #cell(activity)="row">
                                <div class="list-murid text-left">
                                    <label>{{row.item.activity}}</label>
                                </div>
                            </template>
                            <template #cell(activity_date)="row">
                                <div class="list-murid text-left">
                                    <label>{{row.item.activity_date}}</label>
                                </div>
                            </template>
                        </b-table>
                        <div class="d-flex justify-content-lg-end justify-content-center py-2">
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalRows"
                                :per-page="perPage"
                                align="fill"
                                size="sm"
                                class="my-0"
                            ></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </card>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import axios from '../../../axiosHelper';
    // import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
    export default {
        props: {
            type: {
                type: String,
                default: null
            },
        },
        components: {
            // SquareLoader
        },
        data() {
            return {
                isBusy: false,
                showLoader: false,
                items: [
                    { isActive: true, age: 40, name: { first: 'Dickerson', last: 'Macdonald' } },
                    { isActive: false, age: 21, name: { first: 'Larsen', last: 'Shaw' } },
                    {
                        isActive: false,
                        age: 9,
                        name: { first: 'Mini', last: 'Navarro' },
                        _rowVariant: 'success'
                    },
                    { isActive: false, age: 89, name: { first: 'Geneva', last: 'Wilson' } },
                    { isActive: true, age: 38, name: { first: 'Jami', last: 'Carney' } },
                    { isActive: false, age: 27, name: { first: 'Essie', last: 'Dunlap' } },
                    { isActive: true, age: 40, name: { first: 'Thor', last: 'Macdonald' } },
                    {
                        isActive: true,
                        age: 87,
                        name: { first: 'Larsen', last: 'Shaw' },
                        _cellVariants: { age: 'danger', isActive: 'warning' }
                    },
                    { isActive: false, age: 26, name: { first: 'Mitzi', last: 'Navarro' } },
                    { isActive: false, age: 22, name: { first: 'Genevieve', last: 'Wilson' } },
                    { isActive: true, age: 38, name: { first: 'John', last: 'Carney' } },
                    { isActive: false, age: 29, name: { first: 'Dick', last: 'Dunlap' } }
                ],
                fields: [
                    { key: 'full_name', label: 'Nama Lengkap', sortable: true, sortDirection: 'desc', class: 'text-left' },
                    { key: 'activity', label: 'Aktivitas', sortable: false, class: 'text-left'},
                    { key: 'activity_date', label: 'Tanggal', sortable: false, class: 'text-center'}
                ],
                filter_form: {
                    userId: null,
                    startDate: null,
                    endDate: null,
                },
                totalRows: 1,
                currentPage: 1,
                perPage: 25,
                pageOptions: [25, 50, 100, 200, 400, 800, 1000],
                sortBy: '',
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                filterOn: []
            }
        },
        computed: {
            ...mapGetters({
                user: 'getUser',
                userActivityList: 'getUserActivityList',
                userList: 'getUserList',
                token: 'getToken'
            })
        },
        methods: {
            downloadExcel(param) {
                let token = this.token
                let userId = param.userId
                let startDate = param.startDate
                let endDate = param.endDate
                let route = axios.defaults.baseURL+'/v1/user-activity/download/'+userId+'/'+startDate+'/'+endDate+'?token='+token
                window.open(route);
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            getUserActivity(form) {
                this.getUserActivityList(form)
            },
            async getUserActivityList(form) {
                this.isBusy = true
                let userId = form.userId
                let startDate = form.startDate
                let endDate = form.endDate
				await this.$store.dispatch('getUserActivityList', { userId,startDate,endDate })
					.then(() => {
                        this.isBusy = false
					})
					.catch((err)=> {
                        this.isBusy = false
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
            async getUserList() {
                this.isBusy = true
				await this.$store.dispatch('getUserList')
					.then(() => {
                        this.isBusy = false
					})
					.catch((err)=> {
                        this.isBusy = false
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			}
        },
        destroyed() {
            let resp = null
            this.$store.commit('setUserActivityList', { resp })
        },
        mounted() {
            this.totalRows = this.userActivityList.length
        },
        async created() {
            await this.getUserList()
        }
    }
</script>
<style lang="css" scoped>
.line-with-icon svg {
    /* color: #adb7be; */
    position: absolute;
    left: 0;
    top: 0;
    font-size: 1rem;
}
.line-with-icon {
    position: relative;
    padding: 0 0 0 1.75em;
    margin: 0 0 1em;
}
.user-article a {
    color: black;
}
.class-list > .line-with-icon > a{
    color:#ca062a
}
.user-article a:hover {
    color: #ca062a;
}

.btn-open-answer {
    color: #6c757d
}
.btn-open-answer:hover {
    color: #ca062a;
}
</style>